/**
 * @param {Object} error
 * @param {Object} errorDefinition
 * @param {IntlService} intl
 * @param {String} options.currentSchoolId
 * @returns {String}
 */
export function translationForLoginExists(error, errorDefinition, intl) {
  const { currentSchoolId } = errorDefinition
  const { key } = translationMetaForNonUniqueAttr(error, 'login', { currentSchoolId })
  return intl.t(key)
}

/**
 * @param {Object} errorBody
 * @param {Object} error
 * @param {String} options.currentSchoolId
 * @returns {Object}
 *
 * @example
 *
 * const translationMeta = translationMetaForNonUniqueAttr({
 *   code: 'unique',
 *   detail: 'login has already been taken',
 *   title: 'has already been taken',
 *   meta: {
 *     conflict: {
 *       type: 'teacher',
 *       school: '1'
 *     },
 *   },
 *   source: {
 *     pointer: '/data/attributes/login',
 *   },
 *   status: '422',
 * }, 'login')
 *
 * console.log(translationMeta)
 *
 * > {
 *   key: 'validation.loginTakenBy.teacher.otherSchool'
 * }
 *
 */
export function translationMetaForNonUniqueAttr(error, attrName, { currentSchoolId }) {
  const keyPrefix = `validation.${attrName}TakenBy`
  const errorMeta = error?.meta || {}
  return {
    key: _translationKeyForErrorMeta(errorMeta, keyPrefix, currentSchoolId),
  }
}

function _resourceTypeForErrorMeta(errorMeta) {
  return errorMeta?.conflict?.type
}

function _translationKeyForErrorMeta(errorMeta, keyPrefix, currentSchoolId) {
  const resourceType = _resourceTypeForErrorMeta(errorMeta)
  const segments = [keyPrefix, resourceType || 'default']
  if (resourceType === 'teacher') {
    const schoolId = errorMeta?.conflict?.school
    if (schoolId && String(schoolId) !== String(currentSchoolId)) {
      segments.push('otherSchool')
    } else {
      segments.push('currentSchool')
    }
  }
  return segments.join('.')
}
